import React from 'react'

interface ButtonProps {
  idButton: string
  buttonText: string
  disabled?: boolean
  handleClick?: () => void
  className?: string
}

/** Componente bottone che permette la gestione del bottone da utilizzare per eseguire il submit dei dati nelle pagine
 *
 * @param idButton id bottone
 * @param buttonText il testo da visualizzare nel bottone
 * @param disabled se true, il bottone sarà disabilitato e quindi non cliccabile
 * @param handleClick funzione che viene richiamata quando si clicca sul bottone
 * @param className le classi da aggiungere al bottone oltre a quelle definite come default
 */
const Button = ({ idButton, buttonText, disabled, handleClick, className }: ButtonProps) => {
  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    handleClick && handleClick()
  }

  return (
    <button
      id={idButton + '-button'}
      disabled={disabled}
      onClick={handleButtonClick}
      className={
        `bg-bgColor p-4 w-full text-white uppercase text-base font-normal ${disabled ? 'opacity-65 hover:cursor-not-allowed' : ''} desktop:hover:bg-darkestOrangeColor ` +
        className
      }>
      {buttonText}
    </button>
  )
}

export default Button
